var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'pedidos')?_c('view-component',{attrs:{"change_from_dates_option":"","show_btn_delete":false,"show_btn_create":false,"order_list_by":"tienda_nube_order_status","model_name":"tienda_nube_order"},scopedSlots:_vm._u([{key:"model_modal_header",fn:function(slotProps){return [_c('btn-confirmar')]}}],null,false,1772459873)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }